import InformationPanel from "components/Shared/InformationPanel"
import {
	addText,
	addTextWithBulletPoint,
	addTitle,
} from "components/Shared/InformationPanel/utils"
import React from "react"
import { useIntl } from "react-intl"

interface BenchmarkPenetrationInfoProps {
	setIsOpen: (value: boolean) => void
	isOpen: boolean
}

const PenetrationInfoPanel: React.FC<BenchmarkPenetrationInfoProps> = ({
	setIsOpen,
	isOpen,
}) => {
	const intl = useIntl()
	return (
		<div role={"dialog"}>
			<InformationPanel
				title={intl.formatMessage({
					id:
						"phronesis.transactional.application.commercial.benchmark.metric.select.penetration.info.title",
				})}
				isOpen={isOpen}
				onClose={() => setIsOpen(false)}
				content={<PenetrationInfoContent />}
			/>
		</div>
	)
}

const PenetrationInfoContent = () => {
	const intl = useIntl()

	return (
		<>
			{addText(
				"phronesis.transactional.application.commercial.benchmark.metric.select.penetration.info.p1",
				intl
			)}
			{addTitle(
				"phronesis.transactional.application.commercial.benchmark.metric.select.penetration.info.t1",
				intl
			)}
			{addText(
				"phronesis.transactional.application.commercial.benchmark.metric.select.penetration.info.p2",
				intl
			)}
			{addTitle(
				"phronesis.transactional.application.commercial.benchmark.metric.select.penetration.info.t2",
				intl
			)}
			{addTextWithBulletPoint(
				"phronesis.transactional.application.commercial.benchmark.metric.select.penetration.info.p3",
				intl
			)}
			{addTextWithBulletPoint(
				"phronesis.transactional.application.commercial.benchmark.metric.select.penetration.info.p4",
				intl
			)}
			{addTitle(
				"phronesis.transactional.application.commercial.benchmark.metric.select.penetration.info.t3",
				intl
			)}
			{addText(
				"phronesis.transactional.application.commercial.benchmark.metric.select.penetration.info.p5",
				intl
			)}
			{addTitle(
				"phronesis.transactional.application.commercial.benchmark.metric.select.penetration.info.t4",
				intl
			)}
			{addText(
				"phronesis.transactional.application.commercial.benchmark.metric.select.penetration.info.p6",
				intl
			)}
		</>
	)
}

export default PenetrationInfoPanel
